import {Component, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {BookingService} from '../../@shared/new-services/booking.service';
import {ActivatedRoute} from '@angular/router';
import {DatePipe} from "@angular/common";

@Component({
    selector: 'app-shipment-details-and-tracking',
    templateUrl: './shipment-details-and-tracking.component.html',
    styleUrls: ['./shipment-details-and-tracking.component.scss']
})
export class ShipmentDetailsAndTrackingComponent implements OnInit {

    breadcrumbModel: MenuItem[] = [];
    home: MenuItem = {icon: 'pi pi-home', routerLink: '/booking-summary'};
    shipmentDetails: any;
    isLoading: boolean;
    trackingDetailsArray: any[] = [];
    trackingDetails: any;

    constructor(private bookingService: BookingService,
                private activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams
            .subscribe((params) => {
                this.shipmentDetails = {
                    bookingGid: params?.bookingGid,
                    shipmentType: params?.shipmentType,
                    movementType: params?.movementType,
                    bookingId: params?.bookingId,
                };
                this.breadcrumbModel = [
                    {label: 'Booking Summary', icon: '', routerLink: '/booking-summary'},
                    {label: 'Shipment Details : ' + this.shipmentDetails?.bookingId}
                ];
                this.getRealTimeShipmentDetailsAndTracking(this.shipmentDetails?.bookingGid);
            });
    }

    getRealTimeShipmentDetailsAndTracking(bookingId: string, blNumber = '') {
        this.isLoading = true;
        this.bookingService.getShipmentDetails(bookingId, blNumber)
            .subscribe((shipmentDetails) => {
                this.shipmentDetails.builtValues = JSON.parse(shipmentDetails?.builtValues);
                this.shipmentDetails.shipmentTrackingVO = shipmentDetails?.shipmentTrackingVO;
                shipmentDetails.trackingDetailsHeader =
                    this.buildTrackingDetailsHeader(shipmentDetails?.shipmentTrackingVO, shipmentDetails?.shipmentTrackingVO?.shipmentType);
                shipmentDetails.shipmentTrackingVO.shipmentTrackingStatusVOList.map((res) => {
                    if (res?.enabled) {
                        this.trackingDetailsArray.push(res);
                    }
                    if (res?.status === 'Booking Created' || res?.status === 'Initiated') {
                        res.icon = 'assets/branding/shipment-tracking/booking-created.svg';
                    }
                    if (res?.status === 'Booking Confirmed' || res?.status === 'Cargo Carted') {
                        res.icon = 'assets/branding/shipment-tracking/booking-confirmed.svg';
                    }
                    if (res?.status === 'In Progress') {
                        res.icon = 'assets/branding/shipment-tracking/in-progress.svg';
                    }
                    if (res?.status === 'Customs Cleared' || res?.status === 'Custom Clearance Complete' ||
                        res?.status === 'Completed') {
                        res.icon = 'assets/branding/shipment-tracking/customs-cleared.svg';
                    }
                    if (res?.status === 'Truck Placed') {
                        res.icon = 'assets/branding/shipment-tracking/truck-dispatched.svg';

                    }
                    if (res?.status === 'Truck Dispatched') {
                        res.icon = 'assets/branding/shipment-tracking/truck-placed.svg';
                    }
                    if (res?.status === 'Cargo Stuffed') {
                        res.icon = 'assets/branding/shipment-tracking/cargo-stuffed.svg';
                    }

                    if (res?.status === 'Shipment Planned' || res?.status === 'Document Received') {
                        res.icon = 'assets/branding/shipment-tracking/shipment-planned.svg';
                    }
                    if (res?.status === 'Shipment Sailed' || res?.status === 'Shipment Departed') {
                        res.icon = 'assets/branding/shipment-tracking/sailed.svg';
                    }
                    if (res?.status === 'Shipment Arrived') {
                        res.icon = 'assets/branding/shipment-tracking/arrived.svg';
                    }
                    if (res?.status === 'Shipment Delivered' || res?.status === 'Delivered') {
                        res.icon = 'assets/branding/shipment-tracking/delivered.svg';
                    }

                    if (!res.enabled) {
                        res.statusDateTime = null;
                    }
                });
                this.trackingDetails = shipmentDetails;
                this.isLoading = false;
                console.log(this.trackingDetailsArray);
            }, error => {
                this.isLoading = false;
            });
    }

    buildTrackingDetailsHeader(shipmentTrackingVO: any, shipmentType: any) {
        const datePipe = new DatePipe('en-US');
        if (shipmentType === 'FCL' || shipmentType === 'LCL' ||
            shipmentType === 'Transport' || shipmentType === 'Custom Clearance' || shipmentType === 'Service Job') {
            const trackingHeaderDetails =
                {
                    'Booking Number': shipmentTrackingVO?.bookingNumber,
                    'Customer Ref No.': shipmentTrackingVO?.customerReferenceNumber,
                    Vessel: shipmentTrackingVO?.vesselName,
                    Voyage: shipmentTrackingVO?.voyage,
                    'Place of Receipt': shipmentTrackingVO?.placeOfReceipt,
                    'Port of Loading': shipmentTrackingVO?.portOfLoading,
                    'Port of Discharge': shipmentTrackingVO?.portOfDischarge,
                    'Final Place of Delivery': shipmentTrackingVO?.finalPlaceOfDelivery,
                    'Transit Duration': shipmentTrackingVO?.transitDuration ? (shipmentTrackingVO?.transitDuration + ' Days') : '-',
                    'No. of Containers': shipmentTrackingVO?.numberOfContainers,
                };
            if (shipmentType === 'LCL') {
                trackingHeaderDetails['HBL/FCR Number'] = shipmentTrackingVO?.fcrOrHblNumber;
                trackingHeaderDetails['MBL Number'] = shipmentTrackingVO?.mblNumber;
            } else {
                trackingHeaderDetails['HBL Number'] = shipmentTrackingVO?.hblNumber;
                trackingHeaderDetails['MBL Number'] = shipmentTrackingVO?.mblNumber;
            }
            return trackingHeaderDetails;
        }
        if (shipmentType === 'AIR') {
            const trackingHeaderDetails =
                {
                    'Booking Number': shipmentTrackingVO?.bookingNumber,
                    'HAWB Number': shipmentTrackingVO?.hawbNumber,
                    'MAWB Number': shipmentTrackingVO?.mawbNumber,
                    'Customer Ref No.': shipmentTrackingVO?.customerReferenceNumber,
                    'Gross Weight': shipmentTrackingVO?.grossWeight + ' ' + shipmentTrackingVO?.grossWeightUOM,
                    'Transit Duration': shipmentTrackingVO?.transitDuration ? (shipmentTrackingVO?.transitDuration + ' Days') : '',
                    'Flight No 1': shipmentTrackingVO?.flightNo1,
                    'Flight No 2': shipmentTrackingVO?.flightNo2,
                    'Chargeable Weight(KG)': shipmentTrackingVO?.chargeableWeight,
                    Airline: shipmentTrackingVO?.airline,
                    // 'Airport of Loading': shipmentTrackingVO?.origin,
                    // 'Airport of Discharge': shipmentTrackingVO?.destination,
                    Origin: shipmentTrackingVO?.origin,
                    Destination: shipmentTrackingVO?.destination,

                };
            return trackingHeaderDetails;
        }

    }

}
